import apis from 'app/effects/apis'

var effects = {
  apis,
  localStorage: window.localStorage,
}

export default effects
